// Set VITE_USE_EMULATORS=true in .env.local to point the dev server at the
// local Firebase emulators instead of production — see
// local-dev-setup/README.md. Gated on import.meta.env.DEV (true only for
// `vite`/`npm run start`, always false for `vite build`) so a stale
// .env.local can never silently ship a production build pointed at
// localhost — Vite loads .env.local in every mode, build included.
const USE_EMULATORS = false//import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === "true";

export const environment = {
    TURNSTILE_SITE_KEY: "0x4AAAAAACTtmF_89eVndl8K",
    BASE_URL: USE_EMULATORS
        ? "http://127.0.0.1:5001/chatapp-55d4a/us-central1"
        : "https://unilinkd.com/api",
    ANDROID_LINK: "https://play.google.com/store/apps/details?id=org.peers.peers",
    IOS_LINK: "https://apps.apple.com/us/app/unilinkd/id6747821088",
    MAX_ATTENDANCE_REPORT_SIZE: 5 * 1024 * 1024, // 5MB
    MAX_BULK_BOOK_UPLOAD_SIZE: 5 * 1024 * 1024, // 5MB
    USE_EMULATORS,
};
